import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const LockedField = ({ value, onUpgrade, isDescription = false, showUpgradeButton = true, lockText = "Upgrade to view" }) => {
    const displayValue = value || (isDescription ? 'Full investor biography and background information is available with Starter or Pro plan.' : '••••••••');
    const SUBSCRIPTION_FLAG = process.env.REACT_APP_SUBSCRIPTION_FLAG;

    return (
        <Box position="relative" w="100%" minH={isDescription ? "80px" : "auto"}>
            {/* Blurred text layer */}
            <Text
                color="#000"
                className="font-medium select-none"
                opacity={0.5}
                whiteSpace={isDescription ? "pre-wrap" : "normal"}
                wordBreak="break-word"
                style={{
                    filter: 'blur(3px)',
                    WebkitFilter: 'blur(3px)',
                    userSelect: 'none',
                    pointerEvents: 'none',
                }}
            >
                {displayValue}
            </Text>

            {/* Overlay with upgrade button */}
            {SUBSCRIPTION_FLAG == "on" && showUpgradeButton && (
                <Box
                    position="absolute"
                    top="0"
                    left="0"
                    right="0"
                    bottom="0"
                    display="flex"
                    alignItems={isDescription ? "center" : "center"}
                    justifyContent={isDescription ? "center" : "flex-start"}
                    cursor="pointer"
                    onClick={onUpgrade}
                    bg={isDescription ? "rgba(255, 255, 255, 0.7)" : "transparent"}
                    borderRadius={isDescription ? "6px" : "0"}
                    pointerEvents="auto"
                >
                    <Text
                        fontSize="13px"
                        color="#134A70"
                        fontWeight={500}
                        bg={isDescription ? "white" : "transparent"}
                        px={2}
                        py={1}
                        borderRadius="4px"
                        boxShadow={isDescription ? "0 1px 3px rgba(0,0,0,0.1)" : "none"}
                        transition="transform 0.2s"
                        _hover={{ transform: "scale(1.05)" }}
                    >
                        🔒 {lockText}
                    </Text>
                </Box>
            )}

        </Box>
    );
};

export default LockedField;

